import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../config/payrollApiConfig';
import { Tax } from './taxTypes';

// Create
export const createTax = createAsyncThunk(
  'taxes/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.post('/taxes', data);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to create tax');
    }
  }
);

// Get All
export const fetchAllTaxes = createAsyncThunk(
  'taxes/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get('/taxes');
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch taxes');
    }
  }
);

// Get By ID
export const fetchTaxById = createAsyncThunk(
  'taxes/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await payrollServiceApiInstance.get(`/taxes/${id}`);
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to fetch tax');
    }
  }
);

// Update
export const updateTax = createAsyncThunk(
  'taxes/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.put(`/taxes/${id}`, data);
      return { id, data };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to update tax');
    }
  }
);

// Delete
export const deleteTax = createAsyncThunk(
  'taxes/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/taxes/${id}`);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || 'Failed to delete tax');
    }
  }
);
